import React, { useState } from "react";
import "./boxStyle.css";
import ImageInformation from "./ModelMediaContent/ImageInformation";
import type { MediaImage } from "./ModelMediaContent/ImageInformation";

/**
 * The four flag props default to `undefined` on purpose: the handlers below test
 * `!== undefined`, so a caller passes `true` to switch a mode on. Without the
 * optional `boolean` types a `= undefined` default types each prop as
 * `undefined` under strictNullChecks and every caller passing `true` is
 * rejected (SCRUM-1645).
 */
export type ImageProps = {
  image?: MediaImage;
  clickHandler?: (image: MediaImage) => void;
  modelCall?: boolean;
  noInformation?: boolean;
  imageInformation?: boolean;
  onAltSaved?: (publicId: string, alt: string) => void;
};

const Image = ({
  image = {},
  clickHandler = (_image: MediaImage) => {},
  modelCall = undefined,
  noInformation = undefined,
  imageInformation = undefined,
  onAltSaved = undefined,
}: ImageProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (modelCall !== undefined) clickHandler(image);
    if (imageInformation !== undefined && noInformation === undefined) {
      setModalOpen(true);
    }
  };

  const handleCloseModal = () => setModalOpen(false);

  return (
    <>
      <div className="col-auto box-col" onClick={handleClick}>
        <div className="box-img">
          <img src={image.secure_url} alt={image.filename} />
        </div>
        <h4 className="text-center text-primary img-title">
          {image.filename}
        </h4>
      </div>

      {noInformation === undefined && (
        <ImageInformation
          img={image}
          modelCall={modalOpen}
          closeModel={handleCloseModal}
          onAltSaved={onAltSaved}
        />
      )}
    </>
  );
};

export default Image;
